import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { PostJobtime } from "../../../../../../../../redux/job/action";
import { useDispatch } from "react-redux";
import TimePickerRSuite from "../../../../../../../Common/TimePickerRSuite";
import { descriptionvalidation } from "../../../../../../../Common/commonvalidation";
import AsteriskLabel from "../../../../../../../Common/AsteriskLabel";
import { styleforsmallstsar } from "../../../../../../../Common/CommonLabels";
import { formatDurationToHHMM } from "../../../../../../../Common/AllDateTimeReleventFormate";


const LogtimeForm = ({ proposalmilestones, posts, timedata, setTimeData }) => {
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState("");

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      date: timedata?.date || "",
      message: timedata?.message || "",
      start_time: timedata?.start_time || "",
      end_time: timedata?.end_time || "",
    },
    validationSchema: Yup.object({
      date: Yup.string()
        .required("Required")
        .test("not-future", "Future dates are not allowed", (value) => {
          return !value || moment(value).isSameOrBefore(moment(), "day");
        }),
      message: descriptionvalidation,
      start_time: Yup.string().required("Required"),
      end_time: Yup.string()
        .required("Required")
        .test("is-greater", "End time must be later than start time", function (value) {
          const { start_time } = this.parent;
          return moment(value, "HH:mm").isAfter(moment(start_time, "HH:mm"));
        }),
    }),
    onSubmit: (values) => {
      const data = {
        ...values,
        proposal_id: proposalmilestones?.id,
        posts_id: posts?.id,
      };
      dispatch(PostJobtime(data, setLoading));
      formik.resetForm();
    },
  });

  useEffect(() => {
    formik.setValues({
      date: timedata?.date || "",
      message: timedata?.message || "",
      start_time: timedata?.start_time || "",
      end_time: timedata?.end_time || "",
    });
  }, [timedata]);

  useEffect(() => {
    if (proposalmilestones?.started_on) {
      const startDate = new Date(proposalmilestones?.started_on)
        .toISOString()
        .split("T")[0];
      setDate(startDate);
    }
  }, [proposalmilestones]);

  const getHours = (values) => {
    const start = moment(values.start_time, "HH:mm");
    const end = moment(values.end_time, "HH:mm");
    const duration = moment.duration(end.diff(start));
    const hour = duration.asHours();
    return isNaN(hour) ? "" : formatDurationToHHMM(hour);
  };

  return (
    <div className="logged-activity err-position">
      <form onSubmit={formik.handleSubmit} className="logged-row row">
        <div className="form-group col-md-3">
          <label htmlFor="message">Message <AsteriskLabel style1={styleforsmallstsar} /></label>
          <input
            id="message"
            name="message"
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.message}
            placeholder="What have you worked on?"
          />
          {formik.touched.message && formik.errors.message && (
            <div className="err ">{formik.errors.message}</div>
          )}
        </div>

        <div className="start-end col-md-4 clock-size">
          <div className="form-group">
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                marginBottom: "4px",
              }}
            >
              Start Time <AsteriskLabel style1={styleforsmallstsar} />
            </label>
            <TimePickerRSuite
              formik={formik}
              name={`start_time`}
              label=""
            />
            {formik.touched.start_time && formik.errors.start_time && (
              <div className="err" >{formik.errors.start_time}</div>
            )}
          </div>

          <span className="clock-span">-</span>

          <div className="form-group">
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                marginBottom: "4px",
              }}
            >
              End Time <AsteriskLabel style1={styleforsmallstsar} />
            </label>
            <TimePickerRSuite
              formik={formik}
              name={`end_time`}
              label=""
            />
            {formik.touched.end_time && formik.errors.end_time && (
              <div className="err" >{formik.errors.end_time}</div>
            )}
          </div>
        </div>

        <div className="start-end start-endborder col-md-3">
          <div className="form-group">
            <label htmlFor="date" style={{
              marginBottom: "4px",
            }}>Date <AsteriskLabel style1={styleforsmallstsar} /></label>
            <input
              id="date"
              name="date"
              type="date"
              className="form-control px-0"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.date}
              min={date}
              max={moment().format("YYYY-MM-DD")}
            />
            {formik.touched.date && formik.errors.date && (
              <div className="err">{formik.errors.date}</div>
            )}
          </div>
          <div className="form-group">
            <label>Total hours</label>
            <h6 className="mb-0">{getHours(formik.values)}</h6>
          </div>
        </div>

        <div className="col-md-2 d-flex justify-content-end align-items-center">
          <button className="border-button buttons" type="submit" disabled={loading}>
            {loading ? "Loading..." : "Log time"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default LogtimeForm;
